module.exports = __webpack_public_path__ + "static/media/close.377a43e7.svg";